







































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {ServisnaOperacija, StavkaDokumenta} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service';
import {mixins} from "vue-class-component";
import TableEditorsMixin from "@/mixins/table-editors.mixin";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class StavkeServisneOperacije extends mixins(TableEditorsMixin, ComponentBaseMixin) {
    @Prop() stavke!: StavkaDokumenta[];
    @Prop() selektovanaStavka!: StavkaDokumenta;
    @Prop({default: true}) prikaziCenu!: boolean;
    options = {};
    dodajServisnuOperaciju() {
        this.stavke.push(StavkaDokumenta.fromJS({cena: 0}));
    }
    @Emit() dodanaStavka(stavke: StavkaDokumenta) {}
    @Emit() obrisanaStavka(stavke: StavkaDokumenta) {}
}
